import { ProgressBar } from '@tremor/react'
import React, { ReactNode } from 'react'
import { formatValueWithUnit } from '../features/usage/helpers'
import { QUOTA_TYPE_USER_FACING_PROPERTIES_MAP } from '../features/usage/constants'
import { Usage } from '@botpress/client'
import { clamp } from 'lodash'
import { blue, ruby, yellow } from '@radix-ui/colors'

type Props = { description?: ReactNode; title?: ReactNode; color?: string } & Pick<Usage, 'type' | 'value' | 'quota'>
export const UsageProgressBar = ({ quota, type, value, description, title, color }: Props) => {
  const usagePercentage = quota ? clamp((value / quota) * 100, 0, 100) : 0
  color = color || (usagePercentage > 90 ? ruby.ruby8 : usagePercentage > 70 ? yellow.yellow8 : blue.blue8)

  return (
    <div key={type} className="flex flex-col gap-1">
      {title ? title : <p className="text-sm">{QUOTA_TYPE_USER_FACING_PROPERTIES_MAP[type].name}</p>}
      {description}
      <ProgressBar value={usagePercentage} color={color as any} />
      <p className="text-nowrap text-end text-xs text-muted-foreground">
        <span className="font-medium">{formatValueWithUnit(value, type)}</span> of {formatValueWithUnit(quota, type)}
      </p>
    </div>
  )
}
